import React from "react";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQrUrlCode } from "../../actions/profileAction";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { getUserDetail } from "../../utils/helper";
import { profilePostAction } from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import Loader from "../../components/Loader";

const TwoFAsetup = ({
  fromProfile = false,
  closePopup,
  fromLogin,
  userData,
}) => {
  const qrDetails = useSelector((state) => state.profile.qrDetails);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState(fromLogin ? userData : null);
  const initialValues = {
    code: "",
  };

  const validationSchema = Yup.object({
    code: Yup.string().nullable().required("verification code is required"),
  });

  const onSubmit = (values) => {
    setConfirmLoading(true);

    const params = {
      token: localData?.token,
      action: "verifyAuthenticationCode",
      data: {
        secretCode: qrDetails?.secretKey,
        otpCode: values.code,
      },
    };

    dispatch(
      profilePostAction(
        {
          params,
        },
        (status) => {
          if (status) {
            if (fromProfile) {
              closePopup && closePopup();
            } else {
              localStorage.setItem("userDetail", JSON.stringify(localData));
              window.location.href = "/";
            }
          }
        }
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    let localData = getUserDetail();
    dispatch(
      getQrUrlCode(fromLogin ? userData?.token : localData?.token, () => {
        setLoading(false);
      })
    );
    if (!fromProfile) {
      setLocalData(localData);
      localStorage.clear();
    } else if (fromLogin) {
      setLocalData(userData);
    } else {
      setLocalData(localData);
    }
  }, []);

  return (
    <div
      className="login-container"
      style={{
        width: "100%",
        padding: fromProfile ? "0px 35px 0px 65px" : "48px 35px 45px 65px",
      }}
    >
      {fromProfile ? (
        ""
      ) : (
        <>
          <h2 className="login-title">Two Factor Authentication</h2>
        </>
      )}
      <div className="fa-form">
        {loading && <Loader />}
        <div>
          <h5>
            Configuring Google Authenticator or Authy Or Microsoft Authenticator
          </h5>

          <div className="orderedList">
            <li>
              Install Google Authenticator (IOS - Android) or Authy (IOS -
              Android).
            </li>
            <li>In the authenticator app, select "+" icon.</li>
            <li>
              Select "Scan a barcode (or QR code)" and use the phone's camera to
              scan this barcode.
            </li>
          </div>
          <div className="mt-2">
            <h5>Scan QR Code</h5>
            <div className="flex justify-center">
              <img
                className="block w-64 h-64 object-contain"
                src={qrDetails?.qrCodeUrl}
                alt="qrcode url"
              />
            </div>
          </div>
          <div className="mt-2">
            <h5>Or Enter Code Into Your App</h5>
            <p>SecretKey: {qrDetails?.secretKey} (Base32 encoded)</p>
          </div>
          <div>
            <h5>Verify Code</h5>
            <p>
              To activate two factor authentication, please verify the
              authentication code:
            </p>
          </div>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, handleChange, values, setFieldValue }) => {
              return (
                <Form>
                  <div style={{ width: "50%" }}>
                    <FormikControl
                      control="input"
                      type="text"
                      label="Verification Code"
                      placeholder="Enter verification code"
                      name="code"
                      hasError={errors.code && touched.code}
                    />
                  </div>

                  <div className="submit-section">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Verify
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default TwoFAsetup;
